import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AuthThemeWrapper from '@/pages/AuthThemeWrapper';
import { PUBLIC_PATHS } from '@/routes/paths';

// Public pages
const Login = React.lazy(() => import('@/pages/auth/Login'));
const Register = React.lazy(() => import('@/pages/auth/Register'));
const Logout = React.lazy(() => import('@/pages/auth/Logout'));
const ForgetPassword = React.lazy(() => import('@/pages/auth/ForgetPassword'));
const ResetPassword = React.lazy(() => import('@/pages/auth/ResetPassword'));
const AuthCallback = React.lazy(() => import('@/pages/AuthCallback'));
const Landing = React.lazy(() => import('@/pages/landing/'));
const Error404 = React.lazy(() => import('@/pages/error/Error404'));
const Error500 = React.lazy(() => import('@/pages/error/Error500Two'));

const PublicRoutes: React.FC = () => {
  const location = useLocation();
  const isPublic = location.pathname.startsWith('/auth') || location.pathname === PUBLIC_PATHS.landing;
  if (!isPublic) return null;
  return (
    <Routes>
      <Route path={PUBLIC_PATHS.auth.login} element={
        <AuthThemeWrapper>
          <Login />
        </AuthThemeWrapper>
      } />
      <Route path={PUBLIC_PATHS.auth.register} element={
        <AuthThemeWrapper>
          <Register />
        </AuthThemeWrapper>
      } />
      <Route path={PUBLIC_PATHS.auth.logout} element={
        <AuthThemeWrapper>
          <Logout />
        </AuthThemeWrapper>
      } />
      <Route path={PUBLIC_PATHS.auth.forgetPassword} element={
        <AuthThemeWrapper>
          <ForgetPassword />
        </AuthThemeWrapper>
      } />
      <Route path={PUBLIC_PATHS.landing} element={<Landing />} />
      <Route path={PUBLIC_PATHS.auth.resetPassword} element={
        <AuthThemeWrapper>
          <ResetPassword />
        </AuthThemeWrapper>
      } />
      <Route path={PUBLIC_PATHS.auth.callback} element={<AuthCallback />} />
      {/* Error pages */}
      <Route path={PUBLIC_PATHS.errors.error404} element={<Error404 />} />
      <Route path={PUBLIC_PATHS.errors.error500} element={<Error500 />} />
      <Route path="/auth/*" element={<Navigate to={PUBLIC_PATHS.auth.login} replace />} />
    </Routes>
  );
};

export default PublicRoutes;


